<div class="col-12 pb-3">
  <div class="row">
    <div class="col col-12">
      <h1>Request to make payment into the Biodiversity Conservation Fund</h1>
      <p>
      </p>
    </div>
  </div>
</div>
<div>
  <form [formGroup]="fgQuote" novalidate>
    <div class="card">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#quoteDetails">Quote {{this.quote?.referenceNumber}} <span class="pull-right mr-3"><i class="fa fa-arrow-up icon-info" aria-hidden="true"></i></span></h4>
      <div class="collapse show" id="quoteDetails">
        <div class="card-body">
          <div class="col-8 pl-2">
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label ">Quote reference number</label>
              </div>
              <div class="form-group col col-md-4">
                <input id="referenceNumber" formControlName="referenceNumber" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label ">Quote issue date</label>
              </div>
              <div class="form-group col col-md-4">
                <input id="issuedDate" formControlName="issuedDate" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label ">Payment number(s)</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Quote" field="Payment number(s)"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input id="bcfPaymentNumber" formControlName="bcfPaymentNumber" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
           
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-1" id="applicant">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#applicantdiv">A. Development proponent Details</h4>
      <div id="applicantdiv">
        <div class="card-body">
          <div class="col-8 pl-2 mt-3">
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required">Proponent name</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Quote" field="Applicant name"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input id="name" formControlName="name" type="text" maxlength="100" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('name')?.touched && fgQuote.get('name')?.hasError('required')">
                  <small>Proponent name is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required">Proponent type</label>
              </div>
                  <div class="form-group col col-md-4">
                <select id="applicantType" class="form-control" formControlName="applicantType">
                  <option value="">Select proponent type</option>
                  <option value="BUS">Business</option>
                  <option value="IND">Individual</option>
                  <option value="LGOV">Local Government</option>
                  <option value="PART">Partnership</option>
                  <option value="SGOV">State Government</option>
                  <option value="TST">Trust</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label" [class.required]="fgQuote.get('applicantType')?.value !== 'IND'">ABN</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Quote" field="Applicant ABN"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input id="abn" formControlName="abn" type="text" maxlength="15" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('abn')?.touched && fgQuote.get('abn')?.hasError('required')">
                  <small>ABN, ACN or ARBN is required.</small>
                </div>
                <div class="text-danger" *ngIf="fgQuote.get('abn')?.touched && !fgQuote.get('abn')?.hasError('required') && fgQuote.get('abn')?.hasError('invalidAbn')">
                  <small>{{fgQuote.get('abn')?.errors?.invalidAbn}}</small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-7 pl-0">
                <app-mailing-address #applicantMailingAddress [skipCountry]="true" [title]="'Proponent\'s Mailing address'" [validate]="true"  [layout]="'horizontal'" [tooltipContext]="mailingAddressTooltipContext"></app-mailing-address>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="card-footer">          
          <button class="btn btn-primary" *ngIf="!viewMode" (click)="updateApplicantDetails()">Update</button>          
        </div> -->
      </div>
    </div>
    <div class="card mt-1" id="contact">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#contactsdiv">B. Contact Details</h4>
      <div class="card-body" id="contactsdiv">
        <div class="row">
          <div class="col-6"><app-contact-details #applicantContact [title]="'Primary contact'" [layout]="'horizontal'" [validate]="true" [tooltipContext]="primaryContactTooltipContext"></app-contact-details></div>
          <div class="col-6"><app-contact-details #secondaryContact [title]="'Secondary contact'" [layout]="'horizontal'" [validate]="false" [tooltipContext]="secondaryContactTooltipContext"></app-contact-details></div>
        </div>
      </div>

    </div>

    <div class="card mt-1" id="development">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#developmentdiv">C. Development details</h4>
      <div id="developmentdiv">
        <div class="card-body">
          <div class="col-8 pl-2 mt-3">
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">Development name</label>
              </div>
              <div class="form-group col col-md-4">
                <input id="developmentName" formControlName="developmentName" type="text" maxlength="100" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('developmentName')?.touched && fgQuote.get('developmentName')?.hasError('required')">
                  <small>Development name is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">Development type</label>
              </div>
              <div class="form-group col col-md-4">
                <select id="developmentType" formControlName="developmentType" class="form-control">
                  <option value="">Select development type</option>
                  <option *ngFor="let developmentType of developmentTypes" [ngValue]="developmentType.id">{{developmentType.name}}</option>
                </select>
                <div class="text-danger" *ngIf="fgQuote.get('developmentType')?.touched && fgQuote.get('developmentType')?.hasError('required')">
                  <small>Development type is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">Local Government Area</label>
              </div>
              <div class="form-group col col-md-4">
                <select id="lga" formControlName="lga" class="form-control">
                  <option value="">Select local government area</option>
                  <option *ngFor="let lgaOption of lgas" [ngValue]="lgaOption.name">{{lgaOption.name}}</option>
                </select>
                <div class="text-danger" *ngIf="fgQuote.get('lga')?.touched && fgQuote.get('lga')?.hasError('required')">
                  <small>Local Government Area is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">NSW statutory approval type </label>
              </div>
              <div class="form-group col col-md-4">
                <select id="offsetType" formControlName="offsetType" class="form-control">
                  <option value="">Select a statutory approval type</option>
                  <option *ngFor="let offsetTypeOption of offsetStatutoryObligationTypes" [ngValue]="offsetTypeOption.name">{{offsetTypeOption.name}}</option>
                </select>
                <div class="text-danger" *ngIf="fgQuote.get('offsetType')?.touched && fgQuote.get('offsetType')?.hasError('required')">
                  <small>NSW statutory approval type is required.</small>
                </div>
              </div>
            </div>
             <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">NSW approval authority</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Development details" field="NSW approval authority"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input formControlName="nswApprovalAuthority" maxlength="100" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('nswApprovalAuthority')?.touched && fgQuote.get('nswApprovalAuthority')?.hasError('required')">
                  <small>NSW approval authority is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">NSW approval date</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Development details" field="NSW approval date"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input formControlName="nswApprovalDate" type="date" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('nswApprovalDate')?.touched && fgQuote.get('nswApprovalDate')?.hasError('required')">
                  <small>NSW approval date is required.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">NSW statutory approval no.</label>
              </div>
              <div class="form-group col col-md-4">
                <input id="nswReference" formControlName="nswReference" type="text" maxlength="50" class="form-control" />
                <div class="text-danger" *ngIf="fgQuote.get('nswReference')?.touched && fgQuote.get('nswReference')?.hasError('required')">
                  <small>NSW statutory approval no. is required.</small>
                </div>
              </div>
            </div>
           
            <div class="row">
              <div class="form-group col col-md-3">
                <label class="control-label required ">Assessment offset scheme</label>
                <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Development details" field="Assessment offset scheme"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <select formControlName="assessmentOffsetScheme" class="form-control">
                  <option value="">Select offset scheme</option>
                  <option value="BAM">BAM</option>
                  <option value="BBAM">BBAM</option>
                </select>
                <div class="text-danger" *ngIf="fgQuote.get('assessmentOffsetScheme')?.touched && fgQuote.get('assessmentOffsetScheme')?.hasError('required')">
                  <small>Assessment offset scheme is required.</small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="form-group col col-md-3 d-flex align-items-start">
                <label class="control-label mb-0 flex-grow-1">Commonwealth Statutory approval no.</label>
                <span class="p-2 flex-shrink-0"><tooltip register="Payment" tab="RTMP" section="Development details" field="Commonwealth statutory approval no"></tooltip></span>
              </div>
              <div class="form-group col col-md-4">
                <input id="commonWealthReference" formControlName="commonWealthReference" type="text" maxlength="50" class="form-control" />
              </div>
            </div>
          </div>
          <div id="payerdiv">
          <div >
             
            <div class="col-12 pl-2 mt-3">
              <div class="col-6">
                <div class="row d-flex align-items-center">
                  <h5>&nbsp;Payer Details</h5>
                  
               </div>
              <div class="row mb-3">
                  <span>&nbsp;Entity making payment</span>
                </div> 
              <div class="row">
                <div class="form-group col ml-2 col-md-4">
                  <label class="control-label required">Is the Proponent above the same entity making the payment?</label>
                </div>
                <div class="form-group col col-md-4">
                  <select formControlName="isPayerSameAsApplicant" class="form-control" [attr.disabled]="viewMode ? true : null" (change)="onPayerSameAsApplicantChange($any($event.target).value)">
                    <option value="">Select</option>
                    <option value="no">No</option>
                    <option value="yes">Yes</option>
                  </select>
                </div>
              </div>
              </div>
            <div *ngIf="fgQuote.get('isPayerSameAsApplicant')?.value === 'no'" class="row ml-2 mt-2">
              <div class="col-6">

              
                <div class="row mt-3">
                  <div class="form-group col col-md-4">
                    <label class="control-label required">Payer name</label>
                    <span class="pl-2"><tooltip register="Payment" tab="RTMP" section="Development details" field="Payer Details"></tooltip></span>
                  </div>
                  <div class="form-group col col-md-4">
                    <input formControlName="payerName" type="text" class="form-control" />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col col-md-4">
                    <label class="control-label required">Payer type</label>
                  </div>
                  <div class="form-group col col-md-4">
                    <select class="form-control" formControlName="payerType">
                      <option value="">Select payer type</option>
                      <option value="BUS">Business</option>
                      <option value="IND">Individual</option>
                      <option value="LGOV">Local Government</option>
                      <option value="PART">Partnership</option>
                      <option value="SGOV">State Government</option>
                      <option value="TST">Trust</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col col-md-4">
                    <label class="control-label" [class.required]="fgQuote.get('payerType')?.value !== 'IND'">Payer ABN</label>
                    <span class="pl-2"><tooltip register="Payment" tab="RTMP" section="Development details" field="Payer ABN"></tooltip></span>
                  </div>
                  <div class="form-group col col-md-4">
                    <input formControlName="payerABN" type="text" maxlength="15" class="form-control" />
                    <div class="text-danger" *ngIf="fgQuote.get('payerABN')?.touched && fgQuote.get('payerABN')?.hasError('required')">
                      <small>Payer ABN, ACN or ARBN is required.</small>
                    </div>
                    <div class="text-danger" *ngIf="fgQuote.get('payerABN')?.touched && fgQuote.get('payerABN')?.hasError('invalidAbn')">
                      <small>{{fgQuote.get('payerABN')?.errors?.invalidAbn}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5 ml-3">
                <app-mailing-address #payerMailingAddress [skipCountry]="true" [validate]="true" title="Payer mailing address"></app-mailing-address>
              </div>
            </div>

            </div>
            <div *ngIf="fgQuote.get('isPayerSameAsApplicant')?.value === 'no'" class="row ml-2 mt-2">
              <div class="col-6">
                <app-contact-details #payerContact [title]="'Payer contact'" [layout]="'horizontal'" [lastNameRequired]="true" [validate]="true"></app-contact-details>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="card-footer">
        <div *ngIf="!isApplicantAndContactValid() || !isDevelopmentDetailsValid() || !fgQuote.get('isPayerSameAsApplicant')?.value || !isPayerDetailsValid()" class="alert alert-danger">
          <ul>
            <li *ngIf="!isApplicantAndContactValid()">Please complete all the mandatory fields (*) in the proponent and primary contact details sections</li>
            <li *ngIf="!isDevelopmentDetailsValid()">Please complete all the mandatory fields (*) in development details section</li>
            <li *ngIf="!fgQuote.get('isPayerSameAsApplicant')?.value">Please select whether the proponent is the same entity making the payment</li>
            <li *ngIf="!isPayerDetailsValid()">Please complete all the mandatory fields (*) in payer details section</li>
          </ul>
        </div>

          <p *ngIf="!viewMode && this.BCFPaymentReferenceNo ==''">Please save the draft application before uploading any documents.</p>
          <button class="btn btn-primary" *ngIf="!viewMode && this.BCFPaymentReferenceNo!= ''" [disabled]="!canUpdate()" (click)="update()">Update</button>
          <button class="btn btn-primary" *ngIf="!viewMode && this.BCFPaymentReferenceNo ==''" [disabled]="!canSaveDraft()" (click)="saveDraft()">Save Draft</button>
          <span class="p-2" *ngIf="!viewMode && this.BCFPaymentReferenceNo ==''"><tooltip register="Payment" tab="RTMP" section="Development details" field="Save"></tooltip></span> 
        </div>
      </div>
    </div>

    <div class="card mt-1" id="creditdetails">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#obligationsdiv">D. Payment for biodiversity credit obligations</h4>
      <div class="card-body" id="obligationsdiv">
          <div class="row" *ngIf="!isRFQAfterAmendment">
            <label class="control-label">Calculation of indexation amount</label>
          </div>
        <div class="row">

          <div class="form-group col-md-4">
            <div class="row">
              <div class="form-group col-md-4">
                <label class="control-label">Quote issue date</label>
              </div>
              <div class="form-group col-md-4">
                <input id="issuedDate1" formControlName="issuedDate" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
          </div>
          <div class="form-group col-md-4">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="control-label">Payment application date</label>
              </div>
              <div class="form-group col-md-4">
                <input id="preparationDate" formControlName="preparationDate" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
          </div>
          <div class="form-group col-md-4" *ngIf="!isRFQAfterAmendment">
            <div class="row">
              <div class="form-group col-md-6">
                <label class="control-label">
                  No. of whole months lapsed
                </label>
              </div>
              <div class="form-group col-md-4">
                <input id="monthsLapsed" formControlName="monthsLapsed" type="text" maxlength="10" class="form-control" />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div *ngIf="!viewMode" class="col">
            <div class="alert alert-info">
              <div class="alert alert-info">
              <span>The tables below identify the credit types included in your quote.</span><br/>
              <span>In the  <strong>Payment details table:</strong></span>
              <ul>
                <li>Select the credit types that you want to make a payment for.</li>
                <li>Enter the number of credits you want to make a payment for.</li>                
              </ul>
              <span>&nbsp;&nbsp;&nbsp;Note that a request to make a payment can include a greater number of credits than the number included in your quote.</span>              
            </div>
              
            </div>
          </div>
        </div>

      <div class="col col-12">
        <h5>Credit details</h5>
        <div class="col col-12">
          <ag-grid-angular style="width: 100%;height:600px"
            class="ag-theme-alpine"
            [rowData]="obligationData"
            [columnDefs]="creditClassColumnDefs"
            [pagination]="true"
            [defaultColDef]="defaultColDef"
            (gridReady)="onCreditsGridReady($event)">
          </ag-grid-angular>
        </div>

        <div class="mt-3"><h5>Payment details</h5></div>

        <div class="col col-12 mt-3">
          <ag-grid-angular #obligationsGrid style="width: 100%; height: 500px;"
                           [getRowStyle]="pinnedRowStyle"
                           class="ag-theme-alpine"
                           [rowData]="obligationData"
                           [columnDefs]="obligationGridColumns"
                           rowSelection='multiple'
                           [suppressRowClickSelection]="false"
                           [isRowSelectable]="isRowSelectable"
                           [pinnedBottomRowData]="pinnedTotalRowData"
                           [pagination]="true"
                           (gridReady)="onGridReady($event)"
                           (cellValueChanged)="onCellValueChanged($event)"
                           [defaultColDef]="defaultColDef">

          </ag-grid-angular>
        </div>       
      </div>
      </div>
    </div>

    <div class="card mt-1" id="notes">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#notesdiv">E. Notes and Disclaimers</h4>
      <div class="card-body" id="notesdiv">
          <div class="row">
            <div class="form-group col col-md-12">
              <p>'Total obligation payment' in the Payment Details table is the Charge as defined and calculated in accordance with Appendix 1 of the <i>Biodiversity Offsets Payment Calculator Order 2026.</i>&nbsp;Includes rounding therefore rounding variations may apply to the final payment amount.</p>
              <p *ngIf="!isRFQAfterAmendment">The monthly indexation is calculated as the number of whole months that have occurred in the period between the quote being issued and the request to make payment being prepared.</p>
              <p *ngIf="!isRFQAfterAmendment">The 'Indexed Obligation payment per credit' is the sum of the Predicted price per credit, Risk premium per credit, Delivery fee per credit and Indexation per credit.</p>
              <p *ngIf="isRFQAfterAmendment">Note that the 'Obligation payment excluding fees' is the sum of the 'Predicted price per credit' and 'Risk premium per credit', multiplied by the number of credits.</p>
              <p>Note that this request to make payment application is only valid for the development name recorded in Section C.</p>
              <p>A payment can only be made for projects with a NSW statutory approval.</p>
              <p>Charges are not negotiable.</p>
            </div>
          </div>
      </div>
    </div>

    <div class="card mt-1" id="supportinformation">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#documentsdiv">F. Supporting information provided</h4>
      <div class="card-body" id="documentsdiv">


        <!-- <h5>Either</h5> -->
        <div class="row">
            <!-- <div class="form-group col-md-12">
              <label class="control-label">Evidence of submitted NSW development application (or similar)</label><br />
              <div class="form-group col-md-12">
                <span class="col-md-6">Evidence from a NSW statutory approval authority</span>

                <div class="input-group">
                 
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #nsw1FileName readonly maxlength="100">
                  
                 
                  <button class="btn btn-primary ml-3" id="nsw1Button" type="button" *ngIf="!viewMode" (click)="nsw1FileInput.click()" >
                    Select File
                  </button>
                </div>
                
               
                <input type="file" #nsw1FileInput style="display:none" (change)="nsw1FileName.value = nsw1FileInput.files[0]?.name; fileSelected($event, 1); uploadFile(1)">
                <div *ngIf="fgQuote.controls['nsw1'].hasError('maxlength')" class="text-danger">
                    File name exceeds max length of 100 characters.
                </div>
              </div>
              
              <span class="col-md-4">Uploaded file:</span> <a class="col-md-4" href="#" (click)="downloadFile('QFNSWDEVFile')">{{QFNSWDEVFile}}</a>
            </div> -->
              
          </div>

        <!--<h5 class="mt-2">Or</h5> -->
        <div class="row">
            <div class="form-group col-md-12">
              <label class="control-label required">NSW statutory approval with offset conditions</label><br />
              <div class="form-group col-md-12">
                <span class="col-md-6">NSW statutory approval, including all conditions of approval relating to the credit retirement obligation</span>

                <div class="input-group">
                  <!-- Read-only text field to show selected file name -->
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #nsw2FileName readonly maxlength="100">
                  
                  <!-- Custom button that triggers the hidden file input -->
                  <button class="btn btn-primary ml-3" id="nsw2Button" type="button" *ngIf="!viewMode" (click)="nsw2FileInput.click()">
                    Select File
                  </button>
                </div>
                
                <!-- Hidden file input -->
                <input type="file" #nsw2FileInput style="display:none" (change)="nsw2FileName.value = nsw2FileInput.files[0]?.name; fileSelected($event, 2); uploadFile(2)">
                <div *ngIf="fgQuote.controls['nsw2'].hasError('maxlength')" class="text-danger">
                    File name exceeds max length of 100 characters.
                </div>
              </div>
              <span class="col-md-4">Uploaded file:</span> <a class="col-md-4" href="javascript void(0)"(click)="downloadFile('QFNSWAPRFile')">{{QFNSWAPRFile}}</a>
            </div>
          </div>
        <p></p>
        <h5 class="mt-2">And</h5>
        <div class="row">
            <div class="form-group col-md-12">
              <label class="control-label">Commonwealth statutory consent (if applicable)</label><br />
              <div class="form-group col-md-12">
                <span class="col-md-6">Commonwealth EPBC Act controlled action approval including all conditions of approval relating to the offset obligation(s) </span>

                <div class="input-group">
                  <!-- Read-only text field to show selected file name -->
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #cwFileName readonly maxlength="100">
                  
                  <!-- Custom button that triggers the hidden file input -->
                  <button class="btn btn-primary ml-3" id="cwButton" type="button" *ngIf="!viewMode" (click)="cwFileInput.click()">
                    Select File
                  </button>
                </div>
                
                <!-- Hidden file input -->
                <input type="file" #cwFileInput style="display:none" (change)="cwFileName.value = cwFileInput.files[0]?.name; fileSelected($event, 3); uploadFile(3)">
                 <div *ngIf="fgQuote.controls['cw'].hasError('maxlength')" class="text-danger">
                    File name exceeds max length of 100 characters.
                </div>
              </div>
              <span class="col-md-4">Uploaded file:</span> <a class="col-md-4" href="javascript:void(0)" (click)="downloadFile('QFCWAPRFile')">{{QFCWAPRFile}}</a>
            </div>
          </div>
        <div class="row">
            <div class="form-group col-md-12 ">
              <label class="control-label">Credit report</label><br />
              <div class="form-group col-md-12">
                <span class="col-md-6">Credit report from the Biodiversity Assessment Method (BAM) Credit Calculator</span>

                <div class="input-group">
                  <!-- Read-only text field to show selected file name -->
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #crFileName readonly maxlength="100">
                  
                  <!-- Custom button that triggers the hidden file input -->
                  <button class="btn btn-primary ml-3" id="crButton" type="button" *ngIf="!viewMode" (click)="crFileInput.click()">
                    Select File
                  </button>
                </div>
                
                <!-- Hidden file input -->
                <input type="file" #crFileInput style="display:none" (change)="crFileName.value = crFileInput.files[0]?.name; fileSelected($event, 4); uploadFile(4)">
                <div *ngIf="fgQuote.controls['cr'].hasError('maxlength')" class="text-danger">
                    File name exceeds max length of 100 characters.
                </div>
              </div>
              <span class="col-md-4">Uploaded file:</span><a class="col-md-4" href="javascript:void(0)" (click)="downloadFile('QFCRFile')">{{QFCRFile}}</a>
            </div>
          </div>
        <div class="row">
            <div class="form-group col-md-12 ">
              <label class="control-label">Equivalence statement (if applicable)</label><br />
              <div class="form-group col-md-12">
                <span class="col-md-6">Statement of assessment of reasonable equivalence of biodiversity credits (if applicable) </span>
                <div class="input-group">
                  <!-- Read-only text field to show selected file name -->
                  <input type="text" class="form-control col-sm-6" placeholder="No file chosen" #esFileName readonly maxlength="100">
                  
                  <!-- Custom button that triggers the hidden file input -->
                  <button class="btn btn-primary ml-3" id="esButton" type="button" *ngIf="!viewMode" (click)="esFileInput.click()">
                    Select File
                  </button>
                </div>
                
                <!-- Hidden file input -->
                <input type="file" #esFileInput style="display:none" (change)="esFileName.value = esFileInput.files[0]?.name; fileSelected($event, 5); uploadFile(5)">
                 <div *ngIf="fgQuote.controls['es'].hasError('maxlength')" class="text-danger">
                    File name exceeds max length of 100 characters.
                </div>
                <!--<input type="checkbox" formControlName="QFEQS" class="form-control col-md-2" />-->
              </div>
              <span class="col-md-4"> Uploaded file: </span><a class="col-md-4" href="javascript void(0)" (click)="downloadFile('QFEQSFile')">{{QFEQSFile}}</a>
            </div>
          </div>
        <div class="row">
          <div class="form-group col-md-12">
            <label class="control-label">GIS shape files</label><span class="col-md-4" [ngClass]="getShapeFileMessageClass()">({{shapeFileMessage}})</span><br />
            <div class="form-group col-md-12 d-flex">
              <span class="col-md-6">GIS shape files (projected / georectified) of the development impact boundary</span>
              <!--<input class="form-control col-md-2" formControlName="QFNSWDEV" type="checkbox" id="exampleCheckbox">-->
              <div class="input-group" *ngIf="!viewMode">
                <button class="btn btn-primary ml-3" *ngIf="!viewMode" [disabled]="(BCFPaymentReferenceNo=='')" (click)="openShapeFileModal()">Upload</button>
                 <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Payment Details" field="Shape file"></tooltip></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mt-1" id="declarations">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#declarationsdiv">G. Declaration</h4>
      <div class="card-body" id="declarationsdiv">
        <div class="row">
          <div class="col col-12">
            <p>
              I/We:
            </p>
            <ul>
              <li>Apply to make payment to the Biodiversity Conservation Fund (BCF) to satisfy the requirement to retire biodiversity credits in accordance with section 6.30 of the BC Act and/or satisfy a Commonwealth EPBC Act offset obligation;</li>
              <li>
                Declare that, where the proponent is an organization or comprises of more than one entity, I have authority to complete this form on behalf of the organization or, if more than one entity, on behalf of all entities;
              </li>
              <li>Declare that the information in this application form (including any attachments) is accurate and up to date to the best of my/our knowledge;</li>
              <li>Understand and acknowledge that it is an offence under section 13.10 of the BC Act to provide information in connection with a matter under this Act (or under Part 5A of the Local Land Services Act 2013 (NSW)) that a person knows, or ought to know, is false or misleading in a material particular. It is also an offence under section 307B of the Crimes Act 1900 (NSW) for a person to give information to a public authority, knowing the information is false or misleading or omits any matter or thing without which the information is misleading.</li>
            </ul>
            <p>I agree and acknowledge that:</p>
            <ul>
              <li>I give permission for the BCT to collect, store and use personal information contained in this application in accordance with the attached privacy notice and for the purpose of assessing the application.</li>
              <li>I give permission for the BCT to access, store and use any information that is held by the Department of Climate Change, Energy, the Environment and Water (DCCEEW) and the BCT, in accordance with the attached privacy notice and for the purpose of assessing the application. This includes information to verify the attributes of the offset obligation credits that are the subject of this application.</li>

            </ul>
            <div class="form-group col">
              <label class="d-flex align-items-center" style="margin-left: 0; padding-left: 0;">
                <input type="checkbox" [disabled]="viewMode" (change)="consentChanged($event,1);" style="width: 16px; height: 16px; margin-right: 10px; flex-shrink: 0;" />  
                <span class="required">I consent to the above agreements and acknowledgements (box to be checked to indicate consent).</span>
              </label>
            </div>

            <ul>
              <li>I give permission for the BCT to publish personal information contained in this application in accordance with the attached privacy notice, including for the purpose of publicly reporting on the offset obligations satisfied by the BCT. This may include publishing the name of the proponent, name of the development, statutory offsetting obligation reference, date of payment (determined when paid) and amount of payment on the BCT's website.</li>
            </ul>
            <div class="form-group col">
              <label class="d-flex align-items-center" style="margin-left: 0; padding-left: 0;">
                <input type="checkbox" [disabled]="viewMode" (change)="consentChanged($event,2);" style="width: 16px; height: 16px; margin-right: 10px; flex-shrink: 0;" />
                <span class="required">I consent to the above agreement (box to be checked to indicate consent).</span>
              </label>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col form-group">
                  <div class="d-flex align-items-center">
                    <label class="control-label mr-3 required">Invoice Required?</label>
                    <select class="form-control mr-3" style="width: 200px;" [disabled]="viewMode" (change)="onInvoiceRequiredChange($event)" #invoiceSelect>
                      <option value="">Select your answer</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    <span *ngIf="invoiceSelect.value === 'yes'">I require an invoice to make a payment (note that issue of an invoice can take up to 15 business days).</span>
                    <span *ngIf="invoiceSelect.value === 'no'">I wish to make payment via EFT (Electronic Funds Transfer) - no invoice required (note payment approval via EFT can take up to 5 business days).</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12">
              <p>
                If the proponent is an organisation or comprises of more than one entity, then a person who has authority should complete this declaration and submit the application on behalf of the organisation or other entities.
              </p>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col form-group form-inline">
                  <label class="control-label col-sm-3 required">Name</label>
                  <input type="text" maxlength="50" formControlName="authName" class="form-control col-sm-8" />
                </div>
              </div>
              <div class="row">
                <div class="col form-group form-inline">
                  <label class="control-label col-sm-3 required" for="authOrganisation">Organisation</label>
                  <input type="text" id="authOrganisation" maxlength="50" formControlName="authOrganisation" class="form-control col-sm-8" />
                </div>
              </div>
              <div class="row">
                <div class="col form-group" style="margin-left:25%;">
                  <input type="radio" value="self" id="authOption" name="authOption" formControlName="authOption" />&nbsp;<strong>I am the proponent</strong><br />
                  <input type="radio" value="autho" id="authOption" name="authOption" formControlName="authOption" />&nbsp;<strong>I am authorised to complete this form and submit it on behalf of the proponent</strong>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="card mt-1" id="privacy">
      <h4 class="card-header  accordion-up" role="button" data-toggle="collapse" data-target="#privacydiv">H. Privacy notice</h4>
      <div class="card-body" id="privacydiv">
        <div class="row">
          <div class="col col-12">
            <p>
              The Biodiversity Conservation Trust of NSW (BCT or we/us) is subject to the Privacy and Personal Information Protection Act 1998 (Privacy Act) in managing your personal information. We are committed to protecting your privacy.
              The BCT is part of the Department of Climate Change, Energy, the Environment and Water (DCCEEW). The DCCEEW Privacy Management Plan describes how the agency meets its privacy obligations.
              This notice describes how the BCT will manage your personal information that you (the primary contact) provide when you apply to make an offset payment into the Biodiversity Conservation Fund (BCF).
              Personal information means information or opinion about an individual whose identity is apparent or can be reasonably ascertained from the information or opinion.
              In the above circumstances you may also provide the personal information of other persons. This could include information about other persons that together comprise the proponent.
              Before providing the personal information of any other person you must first obtain the consent of that person for the BCT to collect their information and for it to be used in accordance with this privacy notice.
            </p>
            <p>
              We may use personal information collected from you for the following purposes:
            </p>
            <ul>
              <li>to assess your application to make an offset payment into the BCF;</li>
              <li>
                to obtain information that is held by DCCEEW and the BCT to assess your application. This includes information to verify the attributes of the offset obligation credits that are the subject of this application;
              </li>
              <li>to assist the BCT and DCCEEW in financial audits and policy development ;</li>
              <li>to include details in the BCT’s annual report of how the BCT has applied the offset and variation rules in securing biodiversity offsets in accordance with clause 6.6(3) of the Biodiversity Regulation 2017 and</li>
              <li>to publicly report on the offset obligations received by the BCT. This may include publishing personal information including the name of the proponent, name of the development, statutory obligation reference, date of payment (determined when paid) and amount of payment on the BCT’s website.</li>
            </ul>
            <p>We may share the personal information that you provide with DCCEEW when it is consistent with the above purposes. </p>
            <p>We will not otherwise disclose your personal information to any other person unless you have provided consent, or we are permitted or required to do so under law.</p>
            <p>There is no legal requirement for you to provide us with your personal information and/or to give us permission to collect, store and use your personal information. However, if you do not provide all required information requested and give permission for the BCT to collect, store and use the information, we may not be able to consider your application.</p>
            <p>There is no legal requirement for you to give permission for the BCT to publish your personal information. If you do not provide consent for your personal information to be published, your application to make a payment into the BCF may still be successful however we will not make your personal information publicly available. </p>
            <p>Your personal information will be stored in a secured database. </p>
            <p>You have the right to access your personal information that we hold. You also have a right to request that we update or amend this information. If you would like more information, or have any questions regarding privacy, then please contact:</p>

            <p>
              <span>NSW Biodiversity Conservation Trust<br /></span>
              <span>Locked Bag 5022<br /></span>
              <span>Parramatta   NSW   2124<br /></span>
              <span>Phone: 1300 992 688<br /></span>
              <span>Email: info@bct.nsw.gov.au<br /></span>
            </p>
          </div>
        </div>
        <div class="row">
          <div *ngIf="!viewMode && showValidationSummary()" class="col-12 alert alert-danger">
            <ul>
              
              <li *ngIf="ObligationPaymentId<=0">Please save the draft application before submitting.</li>
              <li *ngIf="selectedObligationsCount<=0">{{validation_obl_error}}</li>
              <li *ngIf="!this.statutoryUploaded ">Please upload NSW statutory approval with offset conditions.</li>
              <li *ngIf="(!this.consent1 || !this.consent2)">Please tick the consent checkboxes in declaration section.</li>
              <li *ngIf="invoiceSelect.value === ''">Please answer if Invoice is required.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer">
      <button [disabled]="!canSubmitRequest()" *ngIf="!viewMode" (click)="submitRequest()" class="btn btn-primary ml-5">Submit request to make payment</button>
      <span class="p-2"><tooltip register="Payment" tab="RTMP" section="Payment Details" field="Submit"></tooltip></span>
    </div>
  </form>
</div>

